<div
  class="underlined-form-field__container"
  [class.disabled]="parentForm()?.controls[field().key]?.disabled"
  [class.error]="hasErrors"
>
  <mat-form-field [formGroup]="parentForm()" [floatLabel]="'always'">
    <mat-label>{{ field().label }}</mat-label>
    @if (!useMacAddressFormat()) {
      <input
        matInput
        [id]="field().key"
        [placeholder]="field().placeholder"
        [type]="
          field().type === 'password'
            ? (hidePassword ? 'password' : 'text')
            : field().type
        "
        [formControlName]="field().key"
        [autocomplete]="field().autocomplete"
        [required]="field().required"
        [attr.aria-required]="field().required"
        [attr.aria-describedby]="tooltipText() ? field().key + '-tooltip' : null"
      />
    } @else {
      <input
        matInput
        [id]="field().key"
        [placeholder]="field().placeholder"
        [type]="inputType"
        [formControlName]="field().key"
        [autocomplete]="field().autocomplete"
        [required]="field().required"
        [attr.aria-required]="field().required"
        [attr.aria-describedby]="tooltipText() ? field().key + '-tooltip' : null"
        appMacAddressFormat
      />
    }
    @if (iconName() && field().type === "password") {
      <button
        mat-icon-button
        matSuffix
        (click)="hidePassword = !hidePassword"
        [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hidePassword"
        type="button"
      >
        <mat-icon>{{ hidePassword ? "visibility_off" : "visibility" }}</mat-icon>
      </button>
    }
    @if (hasErrors) {
      <mat-error>{{ errorsList[0] }}</mat-error>
    }
    @if (showWarning()) {
      <mat-error>{{ warningMessage() }}</mat-error>
    }
  </mat-form-field>
  @if (tooltipText()) {
    <button
      type="button"
      class="tooltip"
      [attr.aria-describedby]="field().key + '-tooltip'"
      aria-label="More information"
    >
      <mat-icon aria-hidden="true">info</mat-icon>
      <div class="top" role="tooltip" [id]="field().key + '-tooltip'">
        {{ tooltipText() }}
        <i></i>
      </div>
    </button>
  }
</div>
